export function chunkByN<T>(arr: T[], n: number): T[][] {
  if (n === 0 || !n) return [arr];

  const result: T[][] = [];
  for (let i = 0; i < arr.length; i += n) {
    result.push(arr.slice(i, i + n));
  }
  return result;
}
